export const placeData = {
	title: "Informações de contrato",
	description: "Informações gerais da conta",
	loading: "Carregando...",
	accessDenied: {
		title: "Acesso Negado",
		description: "Você não tem permissão para acessar esta tela.",
	},
	error: {
		title: "Erro",
		description: "Ocorreu um erro ao carregar os dados. Tente novamente.",
	},
	sections: {
		general: {
			title: "Geral",
			description: "Informações gerais da conta",
		},
		fees: {
			title: "Taxas",
			description: "Valores representam a taxa que será aplicada sobre os itens abaixo",
		},
		balanceModel: {
			title: "Modelo de saldo",
			description: "Definição de retorno do saldo",
		},
		grabAndGo: {
			title: "Grab and Go",
			description: "Tipo de entrega configurado",
		},
		eventCurrency: {
			title: "Moeda do evento",
			description: "Moeda e proporção usada",
		},
		smartPosSettings: {
			title: "Configurações de SmartPOS",
			description: "Dados de integração",
		},
		communication: {
			title: "Comunicação",
			description: "Envio de mensagens (SMS e WhatsApp)",
		},
	},
	fields: {
		contractNumber: "Número do contrato",
		profile: "Perfil",
		mainVersion: "Versão principal",
		guaranteedMonthlyMinimum: "Mínimo mensal garantido",
		monthlyBillingCap: "Teto mensal de cobrança",
		zigResponsible: "Responsável ZIG",
		placeStatus: "Status do place",
		zigLocation: "Localização Zig",
		rechargeNotIntegratedLimit: "Limite de recarga não integrada",
		nonIntegratedPaymentLimit: "Limite de pagamento não integrado por device e evento",
		localResponsible: "Responsável(is) pelo local",
		minVersion: "Versão mínima do PDV",
		placeClassification: "Classificação do local",
		smsNumbers: "Números para envio de SMS de receita",
		serviceFee: "Taxa de serviço",
		deliveryFee: "Taxa de entrega",
		onlineDeliveryFee: "Taxa de delivery online",
		advanceReservationFee: "Taxa de cobrança antecipada em reservas",
		parentPlaceName: "Place Pai",
		ppuAuthorizationValue: "Valor da pré autorização do app",
		status: {
			active: "Ativo",
			blocked: "Bloqueado",
			inactive: "Inativo",
			paused: "Pausado",
		},
		house: "Casa",
		profileValues: {
			barAndRestaurant: "Bar e Restaurante",
			restaurant: "Restaurante",
			concertHall: "Casa de Shows",
			bar: "Bar",
			nightclub: "Boate",
			park: "Parque",
			sportsArena: "Arena Esportiva",
			other: "Outro",
		},
		processingFee: "Taxa de processamento",
		platformFee: "Taxa da plataforma",
		balanceReturnType: "Tipo de retorno do saldo",
		returnPeriod: "Período de retorno",
		minimumBalance: "Saldo mínimo",
		maximumBalance: "Saldo máximo",
		deliveryType: "Tipo de entrega",
		deliveryTime: "Tempo de entrega",
		deliveryRadius: "Raio de entrega",
		deliveryTypes: {
			counterDelivery: "Entrega no balcão",
			tableDelivery: "Entrega na mesa",
		},
		deliveryPlatforms: {
			ifood: {
				brandName: "IFood",
				settlementDays: "Dias até a liquidação do IFood",
				fee: "Taxa iFood",
				description: "Configurações do IFood",
			},
		},
		delveryOnlineRules: "Regras de delivery online",
		currency: "Nome",
		exchangeRate: "Proporção para moeda do país",
		currencySymbol: "Símbolo",
		decimalPlaces: "Casas decimais",
		integrationStatus: "Status da integração",
		apiVersion: "Versão da API",
		lastSync: "Última sincronização",
		syncFrequency: "Frequência de sincronização",
		smsCost: "Custo do  envio",
		whatsappCost: "Custo do envio",
		whatsappNumber: "Numéro",
		whatsappId: "ID do serviço",
		pushNotifications: "Notificações push",
		placeType: "Tipo do Place",
		placeTypesValues: {
			default: "Padrão",
			delivery: "Delivery",
			transfers: "Repasses",
			advance: "Advance",
			billing: "Cobranças",
		},
		zigFeeShouldBeChargedInDebit: "Cobrar taxa Zig na data de débito",
		hasCustomizedCard: "Depósito caução é do cliente",
		user: "Usuário",
		fiscalPrinters: "Impressoras fiscais",
		name: "Impressoras",
		bankAccountData: "Dados de conta bancária",
		receivingAccount: "Conta de recebimento",
		accountHolder: "Titular da conta",
		documentType: "Tipo de documento",
		digit: "Dígito",
		accountIdentification: "Identificação da conta",
		accountIdentifier: "Identificador da conta",
		cpfCnpj: "CPF/CNPJ",
		accountType: "Tipo de conta",
		accountTypes: {
			conta_corrente: "Corrente",
			conta_poupanca: "Poupança",
			conta_salario: "Salário",
		},
		registrationData: "Dados para cadastrar",
		bankData: "Dados bancários",
		branch: "Agência",
		bank: "Banco",
		bankName: "Nome do banco",
		account: "Conta",
		recharges: "Recargas",
		rechargeValidityCriteria: "Validade e critérios de recarga",
		rechargesExpireIn: "Recargas expiram em",
		remainingRechargeActions: "Ações da sobra de recarga",
		chargeBack: "Expirar ao fim do evento",
		placeOnly: "Gerenciadas pela casa",
		normal: "Gerenciadas pelo Zig",
		// Taxas e valores
		rateType: "Tipo",
		rateTypeLabel: "Tipo de taxa",
		singleRate: "Taxa única",
		segmentedFeeType: "Taxa segmentada",
		singleFeeType: "Taxa única",
		systemFee: "Taxa de sistema",
		inHouseConsumption: "Consumo na casa",
		ticketOfficeRevenue: "Receita de bilheteria",
		rechargeSurplus: "Sobra de recarga",
		bonus: "Bônus",
		fixedFee: "Taxa fixa",
		appFee: "Taxa sobre app",
		prechargeOnlinePaymentFee: "Taxa de pré-carga/pagamento online",
		fixedFeePaymentDay: "Dia do pagamento da taxa fixa",
		anticipationFee: "Taxa de antecipação",
		thirdPartyPaymentFee: "Taxa de pagamento de terceiros",
		// Pagamento com máquina ZigPay
		zigPayMachinePayment: "Pagamento com máquina ZigPay",
		debit: "Débito",
		credit: "Crédito",
		creditOtherFlags: "Crédito (Outras bandeiras)",
		debitOtherFlags: "Débito (Outras bandeiras)",
		replicateRatesForAllFlags: "Replicar taxas para todas as bandeiras?",
		pix: "Pix",
		pixKey: "Chave Pix",
		pixKeyType: "Tipo de Chave PIX",
		yes: "Sim",
		// Vale alimentação
		foodVoucher: "Vale alimentação",
		// Pagamento com máquina integrada em EC do cliente
		integratedMachinePayment: "Pagamento com máquina integrada em EC do cliente",
		machineCommission: "Comissão das maquininhas",
		anticipatedConsumption: "Consumação antecipada",
		anticipatedBar: "Antecipado/Bar",
		ticketOffice: "Bilheteria",
		// Dias até a cobrança
		daysUntilCollection: "Dias até a cobrança",
		daysUntilCollectionDescription:
			"Quantidade de dias para exercer a cobrança e pagamentos nos seguintes formatos",
		collectionDaysDescription:
			"Quantidade de dias para exercer a cobrança e pagamentos nos seguintes formatos",
		// Parcelamento
		installment: "Parcelamento",
		installmentFee: "Taxa de parcelamento",
		maxInstallments: "Número máx. de parcelas",
		notApplicable: "Não se aplica",
	},
};
